import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import salaryClass from "../../../containers/modules/hr/salary-class";

export default function SalaryClassRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="salary-class"
      index
      element={
        <AccessControl
          name={"Salary Class List"}
          auth={authUser}
          component={salaryClass}
        />
      }
    ></Route>
  );
}
